// src/pages/Sitemap.jsx (혹은 너 쓰는 구조에 맞게 위치만 조정)

import React from 'react';
import { useNavigate } from 'react-router-dom';

const Sitemap = () => {
  const navigate = useNavigate();

  const movePage = (path) => {
    navigate(path);
  };

  const moveBusiness = (path) => {
    navigate(path);
  };

  const moveBoard = (cate) => {
    navigate(`/board/${cate}`, { state: { cate } });
  };

  return (
    <div className="sitemap_wrap">
      <div className="sitemap_back">
        <div className="sitemap_container">
          {/* 상단 헤더 영역 */}
          <div className="sitemap_title_box">
            <h1 className="sitemap_title">사이트맵</h1>
            <p className="sitemap_desc">충남산학융합원의 주요 메뉴를 한눈에 확인하실 수 있습니다.</p>
          </div>

          {/* 그리드 영역 */}
          <div className="sitemap_grid">
            {/* 알림 및 소식 */}
            <section className="sitemap_section">
              <div className="sitemap_section_header">
                <h2 className="sitemap_section_title">알림 및 소식</h2>
                <p className="sitemap_section_desc">공지사항과 각종 공고, 보도자료를 확인하실 수 있습니다.</p>
              </div>
              <ul className="sitemap_link_list">
                <li className="sitemap_link_item" onClick={() => moveBoard('notice')}>
                  공지사항
                </li>
                <li className="sitemap_link_item" onClick={() => moveBoard('business')}>
                  사업공고
                </li>
                <li className="sitemap_link_item" onClick={() => moveBoard('education')}>
                  교육공고
                </li>
                <li className="sitemap_link_item" onClick={() => moveBoard('employment')}>
                  채용공고
                </li>
                <li className="sitemap_link_item" onClick={() => moveBoard('bid')}>
                  입찰공고
                </li>
                <li className="sitemap_link_item" onClick={() => moveBoard('news')}>
                  보도자료
                </li>
                <li className="sitemap_link_item" onClick={() => moveBoard('reference')}>
                  자료실
                </li>
                <li className="sitemap_link_item" onClick={() => moveBoard('archive')}>
                  융합원 아카이브
                </li>
              </ul>
            </section>

            {/* 사업분야 */}
            <section className="sitemap_section">
              <div className="sitemap_section_header">
                <h2 className="sitemap_section_title">사업분야</h2>
                <p className="sitemap_section_desc">
                  산학융합지구 조성, 기업지원, 인재양성, 창업육성 사업을 소개합니다.
                </p>
              </div>
              <ul className="sitemap_link_list">
                <li className="sitemap_link_item" onClick={() => moveBusiness('/fusionSupportProgram')}>
                  산학융합지구조성사업
                </li>
                <li className="sitemap_link_item" onClick={() => moveBusiness('/business/chungnamInnovationProject')}>
                  기업지원사업
                </li>
                <li
                  className="sitemap_link_item"
                  onClick={() => moveBusiness('/business/localIndustryTalentDevelopment')}
                >
                  인재양성사업
                </li>
                <li className="sitemap_link_item" onClick={() => moveBusiness('/business/dangjinStartupSupport')}>
                  창업육성사업
                </li>
              </ul>
            </section>

            {/* 기업연구동 */}
            <section className="sitemap_section">
              <div className="sitemap_section_header">
                <h2 className="sitemap_section_title">기업연구동</h2>
                <p className="sitemap_section_desc">
                  입주 안내, 층별 안내, 입주기업 현황과 문의를 확인하실 수 있습니다.
                </p>
              </div>
              <ul className="sitemap_link_list">
                <li className="sitemap_link_item" onClick={() => movePage('/inquiryinfo')}>
                  입주안내
                </li>
                <li className="sitemap_link_item" onClick={() => movePage('/floor')}>
                  층별안내
                </li>
                <li className="sitemap_link_item" onClick={() => movePage('/company')}>
                  입주기업 현황
                </li>
                <li className="sitemap_link_item" onClick={() => moveBoard('inquiry')}>
                  입주문의
                </li>
              </ul>
            </section>

            {/* 보유시설 */}
            <section className="sitemap_section">
              <div className="sitemap_section_header">
                <h2 className="sitemap_section_title">보유시설</h2>
                <p className="sitemap_section_desc">
                  회의실, 전산실습실, 3D프린터, AR/VR, CNC/MCT 등 시설 정보를 제공합니다.
                </p>
              </div>
              <ul className="sitemap_link_list">
                <li className="sitemap_link_item" onClick={() => movePage('/meetingroom')}>
                  회의실
                </li>
                <li className="sitemap_link_item" onClick={() => movePage('/computer')}>
                  전산실습실
                </li>
                <li className="sitemap_link_item" onClick={() => movePage('/printing')}>
                  3D프린터
                </li>
                <li className="sitemap_link_item" onClick={() => movePage('/arvr')}>
                  AR/VR
                </li>
                <li className="sitemap_link_item" onClick={() => movePage('/cnc')}>
                  CNC/MCT
                </li>
                <li
                  className="sitemap_link_item"
                  onClick={() => navigate('/board/facility/write', { state: { step: 1 } })}
                >
                  시설예약
                </li>
              </ul>
            </section>

            {/* 융합원 소개 */}
            <section className="sitemap_section">
              <div className="sitemap_section_header">
                <h2 className="sitemap_section_title">융합원소개</h2>
                <p className="sitemap_section_desc">인사말, 비전과 목표, 조직도, 연혁 등 융합원 전반을 소개합니다.</p>
              </div>
              <ul className="sitemap_link_list">
                <li className="sitemap_link_item" onClick={() => movePage('/intro')}>
                  인사말
                </li>
                <li className="sitemap_link_item" onClick={() => movePage('/vision')}>
                  비전 및 목표
                </li>
                <li className="sitemap_link_item" onClick={() => movePage('/history')}>
                  연혁
                </li>
                <li className="sitemap_link_item" onClick={() => movePage('/organization')}>
                  조직도
                </li>
                <li className="sitemap_link_item" onClick={() => movePage('/introduce')}>
                  소개자료
                </li>
                <li className="sitemap_link_item" onClick={() => movePage('/regulations')}>
                  관리규정
                </li>
                <li className="sitemap_link_item" onClick={() => movePage('/map')}>
                  오시는 길
                </li>
              </ul>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Sitemap;
